import { Http } from '../../../support';

const initialState = {
  isValidForm: false,
  busy: false,
  data: {},
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.password.data = { ...data };
  });
};

const update = async (store, body, id) => {
  store.setState((state) => {
    state.app.usuarios.password.busy = true;
  });

  try {
    let response;

    if (!id) {
      const headers = {
        'X-Tenancy': 'fa/live',
      };

      const params = {
        include: ['cliente', 'empresa', 'permissions'],
      };

      response = await Http.put(`auth/me`, body, {
        headers,
        params,
      });
    } else {
      response = await Http.put(`api/usuarios/${id}`, body);
    }

    store.setState((state) => {
      state.app.usuarios.password.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.password.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.app.usuarios.password.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.usuarios.password = { ...initialState };
  });
};

const UsuarioPasswordStore = {
  state: initialState,
  actions: {
    setPartialState,
    update,
    reset,
  },
};

export default UsuarioPasswordStore;
